/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2021, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *                _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
 */

/**
 * @module bulb-image/bulb-image-rotate
 */

import { Plugin } from 'ckeditor5';
import BulbImageRotateUI from './bulbimagerotateui';

/**
 * The glue image-rotate plugin for Bulb's CKEditor.
 *
 * @extends Plugin
 */
export default class BulbImageRotate extends Plugin {

  /**
   * @inheritDoc
   */
  public static get requires() {
    return [BulbImageRotateUI] as const;
  }

  /**
   * @inheritDoc
   */
  public static get pluginName() {
    return 'BulbImageRotate' as const;
  }
}
